import React from 'react';
import { Button, BackTop } from 'antd';
import { Route, Switch, Link, Redirect } from 'react-router-dom';

import { ROUTES } from './config';
import SignIn from '../containers/SignIn';

const App = ({ match }) => {
  const role = localStorage.getItem('role') || 'member';
  const filterRoutes = ROUTES.filter(route => route.role.includes(role));
  const routes = (
    <>
      {filterRoutes.map(r => <Route key={r.path} path={`${match.url}${r.path}`} component={r.component} />)}
    </>
  );

  const { pathname } = window.location;

  if (filterRoutes.every(r => !pathname.includes(r.path))) {
    return <Redirect to='/insert-quota' />;
  }

  return (
    <div className="gx-main-content-wrapper">
      <div className="daily-functions">
        <Link to="/insert-quota">
          <Button size='large' shape="round" style={{ color: '#e68228' }} icon='folder-add' type="dashed">
            Create
          </Button>
        </Link>
        <Link to="/search/list-quota">
          <Button size='large' shape="round" style={{ color: '#e68228' }} icon='file-search' type="dashed">
            Search
          </Button>
        </Link>
      </div>
      <Switch>
        {routes}
        <Route path={`${match.url}signin`} component={SignIn} />
      </Switch>
      <BackTop />
    </div>
  );
};

export default App;
